import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  //Services Two
  services = [
    {
      icon: 'bi-brush',
      title: 'Brand Design',
      desc: 'We shape visual identities that express your story and connect emotionally with your audience.'
    },
    {
      icon: 'bi-laptop',
      title: 'UI/UX Design',
      desc: 'Crafting intuitive, elegant, and user-friendly interfaces that enhance engagement and usability.'
    },
    {
      icon: 'bi-palette',
      title: 'Graphic Design',
      desc: 'From print to digital, our creatives deliver high-impact visuals aligned with your brand ethos.'
    },
    {
      icon: 'bi-phone',
      title: 'App UI Design',
      desc: 'Modern mobile-first interface designs that are visually consistent and user-centric.'
    },
    {
      icon: 'bi-megaphone',
      title: 'Content Strategy',
      desc: 'We create engaging content strategies that drive traffic and reflect your brand personality.'
    }
  ];

  //Testimonials
  testimonialCarousel: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    center: true,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  clients = [
    {
      title: "Sarah Malik",
      subtitle: "Marketing Manager",
      image: "testimonial-1.jpg",
      desc:"The branding and website design exceeded our expectations. Their team really understood our vision and delivered creative solutions on time."
    },

    {
      title: "James Patel",
      subtitle: "Startup Founder",
      image: "testimonial-2.jpg",
      desc:"Outstanding creativity! They helped us launch a bold digital presence that truly reflects our brand. Highly recommended for startups."
    },

    {
      title: "Maria Chen",
      subtitle: "Creative Director",
      image: "testimonial-3.jpg",
      desc:"Professional, responsive, and visually stunning design work. It felt like having an in-house design team who truly cared about our goals."
    }

  ];

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "vendor-1.jpg"},
    {img: "vendor-2.jpg"},
    {img: "vendor-3.jpg"},
    {img: "vendor-4.jpg"},
    {img: "vendor-5.jpg"},
    {img: "vendor-6.jpg"}
  ];
}
